export const dialogSxProps = {
	".MuiPaper-root": {
		borderRadius: 6,
		paddingBottom: ".15rem",
		width: "703px",
		maxWidth: "none"
	}
};

export const dialogContentSxProps = { paddingBottom: 0 };

export const dialogContentTextSxProps = { padding: ".75rem 1rem" };

export const typographyMainHeadingSxProps = {
	fontFamily: "Baloo",
	margin: "0 auto 20px auto",
	display: "block",
	textAlign: "center",
	lineHeight: 1,
	color: "#333",
	marginBottom: "2.5rem",
	fontSize: "clamp(1rem, 2.4vw, 34px)",
	maxWidth: 360
};

export const gridContainerSxProps = {
	justifyContent: "space-between",
	textAlign: "center",
	marginBottom: "1rem",
	".MuiGrid-root": {
		xs: {
			flexBasis: "100%",
			maxWidth: "100%"
		},
		sm: {
			flexBasis: "32%",
			maxWidth: "32%"
		}
	},
	img: {
		borderRadius: "13px",
		width: "100%",
		height: "auto"
	},
	".title": {
		fontFamily: "Baloo",
		fontSize: "24px",
		color: "#333"
	},
	".desc": {
		lineHeight: "14px",
		marginBottom: 3,
		color: "#000"
	}
};

export const dialogActionsSxProps = {
	justifyContent: "center",
	flexDirection: "column"
};

export const buttonSxProps = {
	paddingTop: ".75rem",
	paddingBottom: ".75rem",
	marginBottom: 1,
	width: {
		xs: "calc(100% - 3rem)",
		sm: "50%"
	},
	marginLeft: 2,
	marginRight: 2
};
